{
  "defaultTitle": "Не удалось зарегистрироваться",
  "defaultMessage": "Пожалуйста, уточните информацию у диспетчера или свяжитесь со складом",
  "backToHomescreen": "Вернуться на главный экран",
  "hideErrorLog": "СКРЫТЬ ЖУРНАЛ ОШИБОК",
  "viewErrorLog": "ПРОСМОТРЕТЬ ЖУРНАЛ ОШИБОК",
  "errorLogMessageLabel": "Сообщение:",
  "errorLogStatusLabel": "Код статуса:",
  "unknown": "Неизвестно"
}
